export default "__VITE_ASSET__Cdnd8iF5__"